"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgTwitterColoured = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { d: "M7.548 21.75c9.056 0 14.01-7.503 14.01-14.01 0-.213 0-.425-.015-.636A10.02 10.02 0 0 0 24 4.555a9.815 9.815 0 0 1-2.828.775 4.94 4.94 0 0 0 2.165-2.724 9.864 9.864 0 0 1-3.127 1.196 4.929 4.929 0 0 0-8.391 4.49A13.98 13.98 0 0 1 1.67 3.148 4.928 4.928 0 0 0 3.195 9.72 4.88 4.88 0 0 1 .96 9.105v.062a4.926 4.926 0 0 0 3.95 4.827 4.917 4.917 0 0 1-2.223.084 4.93 4.93 0 0 0 4.6 3.42A9.878 9.878 0 0 1 0 19.538a13.941 13.941 0 0 0 7.548 2.209", fill: "#1DA1F2" }) }))); };
exports.default = SvgTwitterColoured;
